module.exports = __webpack_public_path__ + "img/首页未定栏目1.7b53ccf6.jpg";